// Parsing for the unit-selection / event timer dates. The "created after the event date" rule
// that used to live here went out with CPI-1241; `toInstant` stays because the
// View-available-units card (CPI-1238) reads the stamped date through it.

export function toInstant(value) {
  if (value === null || value === undefined || value === '') return null;
  if (value instanceof Date) {
    const fromDate = value.getTime();
    return Number.isNaN(fromDate) ? null : fromDate;
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value !== 'string') return null;
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? null : parsed;
}
